<h2 mat-dialog-title>
  @if (icon) {
    @if (isStringIcon) {
      <mat-icon>{{ icon }}</mat-icon>
    } @else if (isObjectIcon) {
      <svg class="icon-24"><use [attr.href]="'assets/images/ok-icons-sprite.svg#' + iconName"></use></svg>
    }
  }
  {{ title }}
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div>
  <div mat-dialog-content>
    <form [formGroup]="formGroup">
      <div class="form-row">
        <mat-form-field class="mdc-textarea-fix">
          <mat-label>Note</mat-label>
          <textarea matInput formControlName="noteField" maxlength="1000"></textarea>
          <mat-hint align="end">{{ noteField.value.length || 0 }}/1000 karakterer</mat-hint>
          @if (noteField.hasError('required') || noteField.hasError('whitespace')) {
            <mat-error>
              <div>Skriv venligst note</div>
            </mat-error>
          }
        </mat-form-field>
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="close()">{{ denyText }}</button>
    <button mat-raised-button (click)="confirm()" [disabled]="!canConfirm">{{ confirmText }}</button>
  </div>
</div>
